import React from 'react'
import { Link } from 'react-router-dom'
import { IconArrowUpRight, IconClock, IconMapPin } from '@tabler/icons-react'

import './styles/findlove.css'

function FindLove() {

    const employments = [
        {
            puesto: "Desarrollador Web",
            ubicacion: "Lima",
            tipo: "Full-time",
            empresa: "Tech Solutions",
            publicacion: "hace 1h"
        },
        {
            puesto: "Diseñador Gráfico",
            ubicacion: "Arequipa",
            tipo: "Part-time",
            empresa: "Creativos Digitales",
            publicacion: "hace 2h"
        },
        {
            puesto: "Contador",
            ubicacion: "Lima",
            tipo: "Full-time",
            empresa: "Contabilidad Moderna",
            publicacion: "hace 5h"
        },
        {
            puesto: "Asistente Administrativo",
            ubicacion: "Piura",
            tipo: "Part-time",
            empresa: "Gestión Eficiente",
            publicacion: "hace 6h"
        },
        {
            puesto: "Asistente de Recursos Humanos",
            ubicacion: "Lima",
            tipo: "Part-time",
            empresa: "Talento Humano",
            publicacion: "hace 9h"
        },
        {
            puesto: "Trabajador de la Construcción",
            ubicacion: "Iquitos",
            tipo: "Full-time",
            empresa: "Obras y Construcciones",
            publicacion: "hace 3h"
        }
    ];    

    return (

        <section className='--findlove'>

            <div className='--tit'>
                <h2>
                    <span>Encuentra un trabajo </span>
                    <span>que te encantará</span>
                </h2>
                <Link to={'/'} className='--a-seemore'>
                    <span>Explorar más</span>
                    <IconArrowUpRight/>
                </Link>
            </div>

            <div className='--grd-cards'>

                {employments.map((employment, i) => (

                    <div className='--card' key={i}>

                        <div className='--card-head'>
                            <div className='--avatar'></div>
                            <button className='--btn'>Aplicar</button>
                        </div>

                        <div className='--card-body'>
                            <h3 aria-label={employment.puesto}>{employment.puesto}</h3>
                            <div className='--content'>
                                <div className='--wrp'>
                                    <IconMapPin/>
                                    <span>{employment.ubicacion}</span>
                                </div>
                                <div className='--wrp'>
                                    <IconClock/>
                                    <span>{employment.tipo}</span>
                                </div>
                            </div>
                        </div>

                        <div className='--line'></div>
                        
                        <div className='--card-foot'>
                            <span>{employment.empresa}</span>
                            <span>{employment.publicacion}</span>
                        </div>

                    </div>

                ))}

            </div>

            <Link to={'/'} className='--a-seemore-bg'>
                <span>Ver más</span>
                <IconArrowUpRight/>
            </Link>

        </section>

    )

}

export default FindLove